import http from '@/services/http.service';

class ClientInformContactService {
  informContact(content: any) {
    return http.post('/order/inform-contact', content).then(({ data }) => data.data);
  }
}

export default new ClientInformContactService();
